import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { DEFAULT_PAGE_SIZE } from '../../constants/generic'
import { formatShow } from '../tvshows/tvshows.format'
import { formatShowBundle } from './showBundles.format'

export function use(
  client: WbsClient,
  showBundles: API['showBundles'],
  _api: API,
  defaults: AdapterDefaults
): void {
  // GET /v3/bundles/tv-shows
  showBundles.getShowBundlesFx.use(
    async ({
      page,
      sortBy,
      sortOrder = defaults.sortOrder,
      count = defaults.count || DEFAULT_PAGE_SIZE,
    }) => {
      const bundles = await payload(
        client.get.api.v3.bundles.tvShows({
          query: {
            page: page || undefined,
            count: count || undefined,
            'sort-by': sortBy || undefined,
            'sort-order': sortOrder || undefined,
          },
        })
      )
      return {
        ...bundles,
        content: bundles.content.map(formatShowBundle),
      }
    }
  )

  // GET /v3/bundles/tv-shows/{bundleId}
  showBundles.getShowBundleInfoBaseFx.use(async ({ bundleId }) => {
    const bundle = await payload(client.get.api.v3.bundles.tvShows(bundleId)())
    return formatShowBundle(bundle)
  })

  // GET /v3/bundles/tv-shows/{id}/content
  showBundles.getShowBundleContentFx.use(
    async ({ bundleId, page, count = defaults.count || DEFAULT_PAGE_SIZE }) => {
      const shows = await payload(
        client.get.api.v3.bundles.tvShows(bundleId).content({
          query: { page: page || undefined, count: count || undefined },
        })
      )

      return {
        ...shows,
        content: shows.content.map(formatShow),
      }
    }
  )

  /**************** $ShowBundleWithContent *******************/
  // to paginate over - paginateShowBundleWithContent
  showBundles.loadShowBundleWithContentFx.use(async ({ count, bundleId }) => {
    const bundleInfo = await showBundles.loadShowBundleInfoForContent({
      bundleId,
    })
    const shows = [
      ...(
        await showBundles.paginateShowBundleWithContent({
          page: 0,
          count,
          bundleId: Number(bundleId),
        })
      ).content,
    ]

    return {
      ...bundleInfo,
      shows,
    }
  })
  /**************** $ShowBundleWithContent *******************/
}
